<template>
  <div class="modal fade" id="view_broadcast" tabindex="-1" role="dialog" style="overflow: auto;">
    <div class="modal-dialog modal-lg" style="width: 50%" role="document">
      <div class="modal-content">
        <div class="modal-header text-center">
          <div style="font-size: 3rem; line-height: normal; overflow-wrap: break-word;">{{ message.title }}</div>
          <div>{{ `來自"${message.sender}"的訊息` }}</div>
          <div><span>{{ `發送日期: ${message.created_datetime}` }}</span></div>
        </div>

        <div class="modal-body">
          <div class="container-fluid">

            <div v-show="message.files.length > 0" class="row" style="margin-bottom: 10px; ">
              <div class="col-md-2">附件:</div>
              <div class="col-md-10" style="display: flex; flex-wrap: wrap;">
                <div v-for="file in message.files" :key="file.id" style="margin:5px 0">
                  <img v-if="checkFile(file.name)" :src="`${api_url}/announcements/${message.id}/files/${file.id}`" style="width: 50px; height: 50px; object-fit: cover;"/>
                  <i v-else class="el-icon-document"/>
                  <a :href="`${api_url}/announcements/${message.id}/files/${file.id}`" :download="file.name" style="overflow-x: hidden; text-overflow: ellipsis; white-space: nowrap; margin-left: 5px; margin-right: 1rem ">{{ file.name }}</a>
                </div>
              </div>
            </div>

            <div class="row" style="margin-bottom: 10px;">
              <div class="col-md-2">內容:</div>
              <div class="col-md-10">
                <div style="height: 300px; overflow-wrap: break-word;">{{ message.content }}</div>
              </div>
            </div>

            <div class="row" style="text-align: center;">
              <el-button type="danger" plain data-dismiss="modal">關閉</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  data () {
    return {
      api_url: this.$store.state.api_url,
      message: {
        content: '',
        course_id: '',
        created_datetime: '',
        files: [],
        id: '',
        is_read: '',
        title: '',
        sender: ''
      }
    }
  },
  methods: {
    checkFile: function (file) {
      if (['jpg', 'jpeg', 'png', 'jfif'].includes(file.split('.')[1])) {
        return true
      }
      return false
    },
    update: function (message) {
      this.message = message
      $('#view_broadcast').modal('show')
    }
  }
}
</script>
